import * as React from 'react';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';
import { useLocation, useParams, useRoutes } from 'js/lib/useRouter';

import { RouteNames } from 'pages/teach-course/constants';

import type Item from 'bundles/author-course/models/Item';
import type SessionItem from 'bundles/author-sessions/models/SessionItem';
import type { ItemGrade } from 'bundles/authoring/common/types/gradebookV2';
import type { ProctorConfig } from 'bundles/authoring/common/types/proctorConfig';
import GradingFullScreenWrapper from 'bundles/grading/components/layout/GradingFullScreenWrapper';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import SGAContentPanel from 'bundles/grading/components/staff-graded-assignments/SGAContentPanel';
import { SGAPageContextProvider } from 'bundles/grading/components/staff-graded-assignments/SGAPageContextProvider';
import SGALeftPanel from 'bundles/grading/components/staff-graded-assignments/left-panel/SGALeftPanel';
import SearchContextProvider from 'bundles/grading/components/staff-graded-assignments/left-panel/search-and-filters/SearchContext';
import SGAExitButton from 'bundles/grading/components/staff-graded-assignments/top-bar/SGAExitButton';
import SGATopBar from 'bundles/grading/components/staff-graded-assignments/top-bar/SGATopBar';
import { exitRoutes } from 'bundles/grading/utils/entryPointUtils';

export type Props = {
  courseId: string;
  courseBranchId: string;
  currentItem: Item;
  sessionItem: SessionItem;
  gradebookGrades: { [userId: string]: ItemGrade };
  isAnonymized: boolean;
  proctorConfigDraft: ProctorConfig;
  // for private sessions only
  groupId?: string;
};

const SGAGrading = (SGAGradingProps: Props) => {
  const routeLocation = useLocation();
  const routeParams = useParams();
  const routes = useRoutes();

  const gradingGroupId = routeLocation.query?.groupId;

  // make sure user gets back to the expected landing page when they come from different entry point
  // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const currentRouteName = routes[routes.length - 1].name;

  const routeOnClose: PatchedLocationDescriptor = {
    name: exitRoutes[currentRouteName],
    params: routeParams,
    query: { ...(gradingGroupId ? { groupId: gradingGroupId } : {}) },
  };

  const isPrivateSession = !!SGAGradingProps.groupId;

  return (
    <SearchContextProvider>
      <SGAPageContextProvider {...SGAGradingProps}>
        <GradingFullScreenWrapper
          routeOnClose={routeOnClose}
          topBarComponent={<SGATopBar />}
          exitButtonOverrideComponent={<SGAExitButton routeOnClose={routeOnClose} />}
          leftPanelComponent={
            isPrivateSession && currentRouteName !== RouteNames.USER_SUBMISSION.rosters_learner_detailed_view_grades ? (
              <SGALeftPanel />
            ) : undefined
          } // do not render left panel when in Learner/Roster flow
          contentPanelComponent={<SGAContentPanel />}
        />
      </SGAPageContextProvider>
    </SearchContextProvider>
  );
};

export default SGAGrading;
